import router from "@/router";
import store from "@/store";
import { jumpSliceInfo } from '@/utils/common'
export function sliceJumpWorkbench (id, str1, str2) {
  const GET_CUR_PRINTER = store.getters['GET_CUR_PRINTER']
  //  跳转到云空间
  if (id == 1) {
    if (router.app["_route"].path == '/cloudSpace') {
      location.reload();
    } else {
      return router.push('/cloudSpace');
    }
  }
  //  远程打印后跳转对应机器详情
  //  当前机器和远程打印选中机器不同时，需要做对应跳转
  //  相同时且为广域网时，重新刷新服务拿到最新的打印信息
  if (id == 2) {
    if (str1 == 'WAN' && str2 == GET_CUR_PRINTER?.id) {
      store.commit('SET_CLOUD_INFO_REFRESH', str2)
    } else {
      jumpPrinterInfo(str1, str2);
    }
  }
}

//  str1:机器环境 str2:机器key
function jumpPrinterInfo (str1, str2) {
  const GET_CLOUD_PRINTER_LIST = store.getters['GET_CLOUD_PRINTER_LIST']
  const type = str1 == 'WAN' ? 'cloud' : 'lan';
  const index = GET_CLOUD_PRINTER_LIST.findIndex(item => item.id == str2)

  if (index == -1 && type == 'cloud') return
  const key = type === 'cloud' ? GET_CLOUD_PRINTER_LIST[index]?.key : str2
  jumpSliceInfo(type, key);
}